export const METODOS_CIERRE = [
  'efectivo',
  'banco',
  'nequi',
  'daviplata',
  'tarjeta',
  'otro',
] as const;

export type MetodoCierre = (typeof METODOS_CIERRE)[number];

export type BalanceByMethod = Record<MetodoCierre, number>;

export interface AggregateLine {
  cierre_metodo: string;
  total: number | string;
}

export interface CierreDiarioRow {
  id: string;
  empresa_id: string;
  fecha: string;
  status: 'abierto' | 'cerrado';
  saldo_inicial_efectivo: number;
  saldo_inicial_banco: number;
  saldo_inicial_nequi: number;
  saldo_inicial_daviplata: number;
  saldo_inicial_tarjeta: number;
  saldo_inicial_otro: number;
  saldo_final_efectivo: number | null;
  saldo_final_banco: number | null;
  saldo_final_nequi: number | null;
  saldo_final_daviplata: number | null;
  saldo_final_tarjeta: number | null;
  saldo_final_otro: number | null;
  override_inicial: boolean;
  override_by: string | null;
  locked_by: string | null;
  locked_at: string | null;
  created_at: string;
  created_by: string | null;
}

export const LABELS_METODO_CIERRE: Record<MetodoCierre, string> = {
  efectivo: 'Efectivo',
  banco: 'Banco / transferencia / PSE',
  nequi: 'Nequi',
  daviplata: 'DaviPlata',
  tarjeta: 'Tarjeta',
  otro: 'Otro',
};

export function emptyBalance(): BalanceByMethod {
  return {
    efectivo: 0,
    banco: 0,
    nequi: 0,
    daviplata: 0,
    tarjeta: 0,
    otro: 0,
  };
}

export function rowToBalanceInicial(row: CierreDiarioRow): BalanceByMethod {
  return {
    efectivo: Number(row.saldo_inicial_efectivo) || 0,
    banco: Number(row.saldo_inicial_banco) || 0,
    nequi: Number(row.saldo_inicial_nequi) || 0,
    daviplata: Number(row.saldo_inicial_daviplata) || 0,
    tarjeta: Number(row.saldo_inicial_tarjeta) || 0,
    otro: Number(row.saldo_inicial_otro) || 0,
  };
}

export function mapCierreDiario(raw: Record<string, unknown>): CierreDiarioRow {
  return {
    id: String(raw.id),
    empresa_id: String(raw.empresa_id),
    fecha: String(raw.fecha),
    status: raw.status === 'cerrado' ? 'cerrado' : 'abierto',
    saldo_inicial_efectivo: Number(raw.saldo_inicial_efectivo) || 0,
    saldo_inicial_banco: Number(raw.saldo_inicial_banco) || 0,
    saldo_inicial_nequi: Number(raw.saldo_inicial_nequi) || 0,
    saldo_inicial_daviplata: Number(raw.saldo_inicial_daviplata) || 0,
    saldo_inicial_tarjeta: Number(raw.saldo_inicial_tarjeta) || 0,
    saldo_inicial_otro: Number(raw.saldo_inicial_otro) || 0,
    saldo_final_efectivo: raw.saldo_final_efectivo != null ? Number(raw.saldo_final_efectivo) : null,
    saldo_final_banco: raw.saldo_final_banco != null ? Number(raw.saldo_final_banco) : null,
    saldo_final_nequi: raw.saldo_final_nequi != null ? Number(raw.saldo_final_nequi) : null,
    saldo_final_daviplata: raw.saldo_final_daviplata != null ? Number(raw.saldo_final_daviplata) : null,
    saldo_final_tarjeta: raw.saldo_final_tarjeta != null ? Number(raw.saldo_final_tarjeta) : null,
    saldo_final_otro: raw.saldo_final_otro != null ? Number(raw.saldo_final_otro) : null,
    override_inicial: Boolean(raw.override_inicial),
    override_by: raw.override_by ? String(raw.override_by) : null,
    locked_by: raw.locked_by ? String(raw.locked_by) : null,
    locked_at: raw.locked_at ? String(raw.locked_at) : null,
    created_at: String(raw.created_at),
    created_by: raw.created_by ? String(raw.created_by) : null,
  };
}
